"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ComponentWrapper = _interopRequireDefault(require("../../helpers/ComponentWrapper"));
var _Svg = _interopRequireDefault(require("../../Svg/Svg"));
var _constants = require("../../constants");
var FlexTextGrid = function FlexTextGrid(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], null, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "text-center"
  }, data.title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-l-4-col-grid margin-top-xl"
  }, data.items && data.items.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: JSON.stringify(item)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-center margin-bottom-sm"
    }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
      className: "icon--md margin-right-xs",
      name: "check-circle",
      fill: _constants.COLORS.BLACK
    }), /*#__PURE__*/_react["default"].createElement("h3", {
      className: "text-md"
    }, item.title)), /*#__PURE__*/_react["default"].createElement("p", {
      className: "d8-u-color-contrast-high text-sm"
    }, item.text));
  })));
};
FlexTextGrid.propTypes = {
  data: _propTypes["default"].object
};
var _default = exports["default"] = FlexTextGrid;